import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'Goldplay',
    fontSize: 50,
    textTransform: 'uppercase',
    margin: '0.2em',
  },
  hr: {
    width: '30%',
  },
  subTitle: {
    fontFamily: 'Goldplay',
    fontSize: 35,
    textTransform: 'uppercase',
    margin: '0.2em',
  },
  containerHeader: {
    margin: '2em 0',
  },
}));

const Header = () => {
  const classes = useStyles();
  return (
    <div className={classes.containerHeader}>
      <p className={classes.subTitle}>Chatterie</p>
      <hr className={classes.hr} />
      <p className={classes.title}>Le domaine de Romy</p>
      <p>Élevage familliale de chats sibérien en Ile-de-France</p>
    </div>
  );
};

export default Header;
